export const FETCH_LOCATIONS_ATTEMPT = 'admin/common/FETCH_LOCATIONS_ATTEMPT'
export const FETCH_LOCATIONS_SUCCESS = 'admin/common/FETCH_LOCATIONS_SUCCESS'
export const FETCH_LOCATIONS_FAILURE = 'admin/common/FETCH_LOCATIONS_FAILURE'

export const FETCH_ORGANIZERS_ATTEMPT = 'admin/common/FETCH_ORGANIZERS_ATTEMPT'
export const FETCH_ORGANIZERS_SUCCESS = 'admin/common/FETCH_ORGANIZERS_SUCCESS'
export const FETCH_ORGANIZERS_FAILURE = 'admin/common/FETCH_ORGANIZERS_FAILURE'

export const FETCH_EVENTTYPES_ATTEMPT = 'admin/common/FETCH_EVENTTYPES_ATTEMPT'
export const FETCH_EVENTTYPES_SUCCESS = 'admin/common/FETCH_EVENTTYPES_SUCCESS'
export const FETCH_EVENTTYPES_FAILURE = 'admin/common/FETCH_EVENTTYPES_FAILURE'

export const FETCH_USERS_ATTEMPT = 'admin/common/FETCH_USERS_ATTEMPT'
export const FETCH_USERS_SUCCESS = 'admin/common/FETCH_USERS_SUCCESS'
export const FETCH_USERS_FAILURE = 'admin/common/FETCH_USERS_FAILURE'
